// Mock data for Sage & Seed landing page

export const offerings = [
  {
    id: 1,
    title: "Conversation Circles",
    description: "Light, supportive chats with topic cards such as family, travel, and favorite foods.",
    icon: "message-circle",
    preview: "Connecting through simple joys"
  },
  {
    id: 2,
    title: "Story Share",
    description: "Short guided storytelling with photos or simple prompts. No pressure to remember details.",
    icon: "book-open",
    preview: "Every story deserves to be heard"
  },
  {
    id: 3,
    title: "Memory Games",
    description: "Friendly, low-stakes activities like picture match, name-that-tune, or finish-the-proverb.",
    icon: "puzzle",
    preview: "Play without pressure"
  },
  {
    id: 4,
    title: "Music Moments",
    description: "Listen together, sing along, or identify familiar tunes. Volume and pace are participant-led.",
    icon: "music",
    preview: "Melodies that spark memories"
  },
  {
    id: 5,
    title: "Gentle Movement",
    description: "Seated stretches or mirror-me gestures that can spark smiles and engagement.",
    icon: "activity",
    preview: "Joy in every motion"
  },
  {
    id: 6,
    title: "Creative Time",
    description: "Doodle together or color simple images. The point is presence, not performance.",
    icon: "palette",
    preview: "Creating moments together"
  }
];

export const benefits = {
  caregivers: [
    {
      title: "Respite with Peace of Mind",
      description: "Meaningful engagement for your loved one while you rest, knowing they're in caring company"
    },
    {
      title: "Mood & Engagement Support",
      description: "Regular social connection shown to improve mood, reduce isolation, and enhance quality of life"
    },
    {
      title: "Flexible & Safe",
      description: "Sessions on your schedule, monitored for safety, with AI support and multilingual options"
    }
  ],
  students: [
    {
      title: "Build Deep Empathy",
      description: "Learn patience, perspective, and the art of truly listening to another generation"
    },
    {
      title: "Gain Real Purpose",
      description: "Make a tangible difference in someone's day while developing skills that matter"
    },
    {
      title: "Flexible Volunteering",
      description: "Commit to sessions that fit your schedule, with training and AI guidance provided"
    }
  ]
};

export const researchArticles = [
  {
    id: 1,
    title: "The Impact of Intergenerational Programs on Dementia Care",
    source: "Journal of Gerontology",
    year: "2023",
    summary: "Research demonstrates significant improvements in mood and cognitive engagement through structured intergenerational interactions."
  },
  {
    id: 2,
    title: "Social Engagement and Quality of Life in Neurodegenerative Conditions",
    source: "Dementia Care Research",
    year: "2024",
    summary: "Regular social connection reduces feelings of isolation and supports emotional well-being in seniors with cognitive decline."
  },
  {
    id: 3,
    title: "Digital Platforms for Remote Caregiving Support",
    source: "Healthcare Innovation Quarterly",
    year: "2024",
    summary: "Technology-mediated social programs show promise in extending care networks and providing respite for family caregivers."
  }
];

export const testimonials = [
  {
    name: "Margaret Chen",
    role: "Daughter & Caregiver",
    quote: "Seeing my mother light up during her sessions with Emma has been a gift. It gives me time to breathe, knowing she's genuinely happy."
  },
  {
    name: "David Kim",
    role: "High School Senior",
    quote: "I started volunteering for college apps. I stayed because Mr. Roberts teaches me more about life than any classroom ever could."
  },
  {
    name: "Sarah Williams",
    role: "Memory Care Coordinator",
    quote: "Sage & Seed has become an essential part of our residents' weekly routine. The joy and connection are unmistakable."
  }
];

export const sessionSteps = [
  {
    step: 1,
    title: "Match & Connect",
    description: "We pair seniors with trained young adults based on interests, language, and personality"
  },
  {
    step: 2,
    title: "Gentle Video Call",
    description: "One-to-one online sessions (30-45 min) in a safe, monitored environment"
  },
  {
    step: 3,
    title: "Choose Activities",
    description: "Select from music, stories, photos, crafts, or simply warm conversation"
  },
  {
    step: 4,
    title: "AI-Assisted Support",
    description: "Real-time prompts help guide conversations naturally, in any language"
  }
];
